import { NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute, Router } from '@angular/router';
import { CourseManagementService } from '@edtech-ui/core/services/course-management/course-management.service';
import { alphanumericValidator, numberValidator } from '@edtech-ui/core/utils/create-course-validators';
import { ToastrService } from 'ngx-toastr';
import { min } from 'rxjs';


@Component({
  selector: 'app-course-creation-new-form',
  standalone: true,
  imports: [ReactiveFormsModule, MatIconModule, NgIf],
  templateUrl: './course-creation-new-form.component.html',
  styleUrl: './course-creation-new-form.component.scss'
})
export class CourseCreationNewFormComponent {


  createCourseForm!: FormGroup;
  classroomId: string = '';

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private courseService: CourseManagementService,
    private toast : ToastrService
  ) {
    const payload = this.courseService.getPayload();

 this.createCourseForm = new FormGroup({
  course_title: new FormControl(payload.course_title, [
    Validators.required,
    Validators.pattern(/^[A-Za-z .,;&'-]+$/)
  ]),
  course_code: new FormControl(payload.course_code, [
    Validators.required,
    Validators.maxLength(30),
    Validators.pattern(/^[A-Za-z0-9 .,;&'-]+$/)
  ]),
  grade_level: new FormControl(payload.grade_level, [
    Validators.required,
    alphanumericValidator,
    Validators.maxLength(30),
    Validators.min(1)
  ]),
  credits: new FormControl(payload.credits || '', [
    Validators.pattern(/^[0-9]+$/) 
  ]),
  cie_marks: new FormControl(payload.internal_marks || '', [
    Validators.pattern(/^[0-9]+$/)
  ]),
  see_marks: new FormControl(payload.exam_marks || '', [
    Validators.pattern(/^[0-9]+$/)
  ]),
});

    this.createCourseForm.valueChanges.subscribe(val => {
      this.courseService.updatePayload({
        course_title: val.course_title,
        course_code: val.course_code,
        grade_level: val.grade_level,
        credits: val.credits,
        internal_marks: val.cie_marks,
        exam_marks: val.see_marks
      });
    });
  }

  ngOnInit(): void {
    this.route.parent?.paramMap.subscribe(params => {
      this.classroomId = params.get('classroomId') ?? '';
    });
  }

goToNextPage() {
  const formValues = this.createCourseForm.value;

  // Convert to number only if value is entered, else leave as null
  const credits = formValues.credits ? Number(formValues.credits) : null;
  const cie_marks = formValues.cie_marks ? Number(formValues.cie_marks) : null;
  const see_marks = formValues.see_marks ? Number(formValues.see_marks) : null;

  // Show toast if any entered value is 0
  if (credits === 0 || cie_marks === 0 || see_marks === 0) {
    this.toast.error('Credits, CIE Marks, and SEE Marks cannot be 0.');
    return; // stop navigation
  }

  // Check required fields
  if (
    this.createCourseForm.get('course_title')?.invalid ||
    this.createCourseForm.get('course_code')?.invalid ||
    this.createCourseForm.get('grade_level')?.invalid
  ) {
    this.toast.error('Please fill all required fields with valid values.');
    return;
  }

  // Navigate if validations pass
  this.router.navigate([
    '/teacher-dashboard',
    this.classroomId,
    'manual-course-creation',
    'objective'
  ]);
}



}